import { thunk } from 'easy-peasy';

import api from '~/services/api';
import { IThunkGetHospitalDetails } from '../types';

const onGetHospitalDetails: IThunkGetHospitalDetails = thunk(async ({ setHospitalDetails }, id) => {
  const data = await api.hospital.getById(id).then(res => res.data);

  setHospitalDetails(data ?? null);
});

export default onGetHospitalDetails;
